import {useQuery} from 'react-query';
import {paymentAPI} from 'api';
import {getSupportedCurrencies} from 'api/routes/wallet';

export const useSupportedCurrencies = publicKey => {
    const query = useQuery(
        ['supported-currencies', publicKey],
        async () => {
            const response = await paymentAPI.get(getSupportedCurrencies, {
                headers: {Authorization: publicKey},
            });
            return response.data;
        },
        {
            enabled: !!publicKey,
            retry: false,
            refetchOnWindowFocus: false,
            staleTime: Infinity,
        }
    );

    // No publicKey means the query stays disabled and this resolves to {} —
    // callers should treat a missing minimum as "nothing to enforce", not as blocked.
    const currencies = query.data?.data ?? [];
    const activeCurrencies = currencies.filter(c => !c.isDisabled);
    const minimumAmountByCurrency = Object.fromEntries(
        activeCurrencies.map(c => [c.currency, c.minimumAmount])
    );
    const defaultCurrency = activeCurrencies.find(c => c.isDefault)?.currency;

    return {...query, activeCurrencies, minimumAmountByCurrency, defaultCurrency};
};
